export const NAVBAR_DEFAULT = 'NAVBAR_DEFAULT'
export const NAVBAR_INVERSE = 'NAVBAR_INVERSE'



/** WEBPACK FOOTER **
 ** ./src/vuex/mutation-types.js
 **/